import { Component } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-skeleton-product-list',
  imports: [NgxSkeletonLoaderComponent],
  templateUrl: './skeleton-product-list.component.html',
  styleUrl: './skeleton-product-list.component.scss',
})
export class SkeletonProductListComponent {}
